<div class="full-page-template">
  <div class="breadcrumbs">
    <ng-content select="[breadcrumbs]"></ng-content>
  </div>
  <div class="title">
    <ng-content select="[title]"></ng-content>
  </div>
  <div class="body">
    <div class="full-page-template__card">
      <ng-content select="[card]"></ng-content>
    </div>
    <nz-divider></nz-divider>
    <div class="footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>
